import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { AudioLines } from 'lucide-react';
import styles from "../../cards.module.scss"

function EventItem({ event, handleClickEvent, handleDuplicateEvent, layout }) {
  return (
    <div
      className={`${styles.projectCard}`}
      onClick={handleClickEvent}>
      <img
        className={styles.projectImage}
        src={event.main_image ? event.main_image.file : getImage('img-ph.png')}
        alt={event.main_image ? event.main_image.label : 'Non renseignée'}
      />
      <img
        className={styles.projectImage}
        src={event.secondary_image ? event.secondary_image.file : getImage('img-ph.png')}
        alt={event.secondary_image ? event.secondary_image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <p className={styles.subtitle}>{`${event.place_name} `}</p>
          <p className={styles.subtitle}>{`${moment(event.start_dt).format('lll')}`}</p>

        </div>

        <div className={styles.tagList}>
          <Tag tag={getConstant('melismes.common.statusTypes', event.status)} />
          <Tag
            tag={{
              label: event.program?.title,
              bgColor: 'bg-slate-700',
              icon: AudioLines
            }}
          />
        </div>
      </div>

      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer l'évènement"
        tooltipOptions={{ position: 'left' }}
        onClick={(e) => {
          e.stopPropagation();
          handleDuplicateEvent(event);
        }}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default EventItem;
